/**
 * Controller for the vd-carousel-frame component.
 *
 * @class VdCarouselFrameController
 */
export default class VdCarouselFrameController {
  constructor($attrs, $element) {
    'ngInject'
    this._$attrs = $attrs
    this._$element = $element
  }

  $onInit() {
    this.vdCarousel.registerFrame(this)
  }

  /**
   * Set the active state of this carousel frame.
   *
   * @method setActive
   *
   * @param {Boolean} active
   *        Whether or not this frame should be active
   * @param {String} transitionDirection
   *        The direction the frame should transition in/out. Supported values are 'left' or 'right'.
   */
  setActive(active, transitionDirection) {
    if (this.active === active) {
      return
    }

    this.active = active
    this._$attrs[active ? '$addClass' : '$removeClass'](
      'vd-carousel-frame-active'
    )

    this._applyTransitionClass(transitionDirection)
  }

  /**
   * Apply the appropriate transition CSS class for the given direction. If a class is applied it is removed again
   * on animationend.
   *
   * @private
   * @method _applyTransitionClass
   *
   * @param {String} transitionDirection
   *        The direction the frame should transition in/out. Supported values are 'left' or 'right'.
   */
  _applyTransitionClass(transitionDirection) {
    if (!transitionDirection) {
      return
    }

    const transitionClass = `vd-carousel-frame-transition-${transitionDirection}`
    this._$attrs.$addClass(transitionClass)
    this._$element.one('animationend', () => {
      this._$element.removeClass(transitionClass)
    })
  }
}
